<template>
  <div class="emd-onboarding">
    <div class="emd-onboarding__wrapper" v-for="(item, i) in onboarding" :class="{ 'eu-display_none': i !== step  }" :key="item.id" :ref="item.id">
      <emd-pulse :class="item.pulseDirection" />
        <div class="emd-container _content_spaced">
          <div>
            <emd-status-bar :status="'primary'" />
            <div class="emd-container__header eu-justify_end eu-align-items_start">
              <button class="emd-btn _type_link _color_tertiary" @click="close">
                <i class="uil uil-times"></i>
              </button>
            </div>
          </div>
          <div class="emd-container__content eu-align_center">
            <div v-if="item.hasImage" class="emd-onboarding__image">
              <emeraldraw :draw="`onboarding/${item.id}`" />
            </div>
            <div class="emd-text _color_default">
              <h2 class="emd-text _size_page _color_default">
                <span v-if="item.showStepNumber">{{i + 1}}. </span>{{$t(`${item.id}.title`)}}
              </h2>
              <div class="eu-my_5" v-html="$t(`${item.id}.text`)"></div>
            </div>
          </div>
          <div class="emd-container__footer eu-align_center eu-mb_3" >
            <div class="eu-flex eu-justify_end eu-mb_3 eu-px_4">
              <button class="emd-btn _color_tertiary" @click="close">{{ $t(`${item.id}.button`) }}</button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import EmdPulse from '@/components/emerald/atoms/EmdPulse.vue'
import { createPopper } from '@popperjs/core'
import { EmdStatusBar } from 'emerald-vue/src/components'
import Emeraldraw from '@/components/emerald/atoms/Emeraldraw.vue'

export default {
  name: 'Onboarding',
  components: {
    EmdPulse,
    EmdStatusBar,
    Emeraldraw
  },
  data () {
    return {
      onboarding: [
        {
          id: 'welcome',
          pulseDirection: 'eu-right_5 eu-top',
          showStepNumber: false,
          hasImage: true,
          popper: {
            placement: 'bottom-start',
            offset: [-8, 0],
            instance: null
          }
        },
        {
          id: 'congratulations',
          pulseDirection: 'eu-bottom eu-right_negative_10',
          showStepNumber: false,
          hasImage: false,
          popper: {
            placement: 'left-start',
            offset: [-30, 10],
            instance: null
          }
        }
      ],
      previousStep: null
    }
  },
  computed: {
    showGreeting () {
      return this.$store.getters.onboarding.show_greeting
    },
    orderCreated () {
      return !this.$store.getters.order_created && (this.$route.name === 'OrderCreated')
    },
    step () {
      if (this.showGreeting) {
        return 0
      } else if (this.orderCreated) {
        return 1
      }
      return null
    }
  },
  watch: {
    step (newValue, oldValue) {
      this.previousStep = oldValue
      this.goToStep(newValue)
    }
  },
  created () {
    /**
      adiciona atributo data-onboarding para referência
      do onboarding no botão de FEEDBACK gerado pelo jira
    */
    const feedbackbutton = document.querySelector('[id="atlwdg-trigger"]')
    feedbackbutton.setAttribute('data-onboarding', 'congratulations')
  },
  mounted () {
    this.goToStep(this.step)
  },
  methods: {
    close () {
      if (this.showGreeting) {
        this.$store.dispatch('CLOSE_GREETING')
      } else {
        this.$store.dispatch('SET_INITIAL_ORDER_CREATED', true)
      }
    },
    createPopperInstance (step) {
      const reference = document.querySelector(`[data-onboarding="${step.id}"]`)
      const popper = this.$refs[step.id][0]
      if (reference && popper) {
        step.popper.instance = createPopper(reference, popper, {
          placement: step.popper.placement,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: step.popper.offset
              }
            },
            {
              name: 'eventListeners',
              enabled: true
            }
          ]
        })
      }
    },
    goToStep (step) {
      const nextIndex = step
      const currentIndex = this.previousStep
      /* remove display: none do popper para o posicionamento do popper ficar correto */
      if (nextIndex !== null && nextIndex >= 0 && nextIndex < this.onboarding.length) {
        if (!this.onboarding[nextIndex].popper.instance) {
          this.createPopperInstance(this.onboarding[nextIndex])
        }
        this.showStep(this.onboarding[nextIndex])
      }
      if (currentIndex !== null) { this.hideStep(this.onboarding[currentIndex]) }
    },
    hideStep (step) {
      step.popper.instance.setOptions({
        modifiers: [{ name: 'eventListeners', enabled: false }]
      })
    },
    showStep (step) {
      step.popper.instance.setOptions({
        modifiers: [{ name: 'eventListeners', enabled: true }, { name: 'offset', options: { offset: step.popper.offset } }]
      })
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "welcome": {
      "title":  "Bem-vindo ao Shop!",
      "text": "Adicione os primeiros itens ao seu pedido e comece a vender.<br><br>Aqui você também pode experimentar a nova versão do nosso cabeçalho. Utilize os atalhos para acessar rapidamente a página da empresa, seu perfil ou produtos.",
      "button": "Ok!"
    },
    "congratulations": {
      "title": "Parabéns, você criou o seu primeiro pedido!",
      "text": "Esperamos que você tenha tido uma boa experiência com a criação de pedidos e a nova navegação. Mas queremos ouvir de você, utilize nossa área de feedbacks e conte como foi.",
      "button": "Fechar"
    }
  },
  "en-US": {
    "welcome": {
      "title":  "Welcome to Shop!",
      "text": "Add the first items to your order and start selling.<br><br>Here you can also experience a new version of our header. Use the shortcuts to quickly access the company's page, your profile and products.",
      "button": "Ok!"
    },
    "congratulations": {
      "title": "Congratulations, you created your first order!",
      "text": "We hope you had a good experience with the order creation and the new navigation. But we would like to hear from you, use our feedbacks' area and tell how was it.",
      "button": "Close"
    }
  }
}
</i18n>
